import React, { Component } from 'react'
import { Button, Tooltip } from 'antd'

export default class extends Component {
  handleClick = () => {
    const { downloadStorageFile, rows, clearDownloadList } = this.props

    clearDownloadList()

    for (const i in rows) {
      downloadStorageFile(rows[i])
    }
  }

  render () {
    return (
      <Tooltip title='Download'>
        <Button
          type='dashed'
          icon='download'
          onClick={this.handleClick}
        />
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/ButtonDownload/ButtonDownload.jsx